import { createContext, useContext } from 'react';

export interface DrawerContextProps {
    close: () => void;
    open: () => void;
    isContentScrollable?: boolean;
    isOpen: boolean;
    contentRef?: any;
}

export const DrawerContext = createContext<DrawerContextProps>({
    isOpen: false,
    close: () => undefined,
    open: () => undefined,
});
export const useDrawerContext = () => useContext(DrawerContext);
